import { useIsFetching } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { t } from "ttag";

import { appQueriesStore } from "@/app/api";
import { usePortalUserStore } from "@/app/stores";
import { useBoolean } from "@/shared/hooks";
import { Button, Dialog, VideoCameraIcon } from "@/shared/ui";
import { EMBEDDABLES_ROUTE } from "../router";

export const EmbeddablesMandatorySyncModal = () => {
  const needsEmbeddablesInitialSync = usePortalUserStore(
    (state) => state.needsEmbeddablesInitialSync,
  );

  const isFetchingUser = useIsFetching({
    queryKey: appQueriesStore.user.queryKey,
  });

  const { value: open } = useBoolean(needsEmbeddablesInitialSync);

  const embeddablesSubscription = usePortalUserStore(
    (state) => state.portalUser?.subscriptions[0],
  );

  const navigate = useNavigate();

  if (!embeddablesSubscription || !needsEmbeddablesInitialSync) {
    return null;
  }

  const handleSchedule = () => {
    return navigate(EMBEDDABLES_ROUTE.SCHEDULE_APPOINTMENT);
  };

  return (
    <Dialog.Root open={open && !isFetchingUser}>
      <Dialog.Content withCloseButton={false}>
        <Dialog.Header icon={VideoCameraIcon}>
          <Dialog.Title>{t`You're almost there!`}</Dialog.Title>

          <Dialog.Description>
            {t`To get started with LevelsRx, you'll need a quick video visit with one of our medical providers. This helps us personalize your care and ensure it's safe to begin your medication.`}
          </Dialog.Description>
        </Dialog.Header>

        <Dialog.Footer>
          <Button onClick={handleSchedule} size="lg">
            {t`Schedule now`}
          </Button>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog.Root>
  );
};
